import React from 'react';
import Money from '../Money';

const Balance = ({customer, balance, className}) => {

    const _balance = balance ?? customer?.balance ?? 0;

    return <Money pence={_balance} colour={true} className={className} />
}

export default Balance;